<template>
  <div class="allGoods_container">
    <div class="content">
      <category v-if="show" @sendType="sendType" @sendSearch="sendSearch" :total="total" />
      <el-breadcrumb v-if="!show" separator="/" class="mt_20 branditem"  >
        <el-breadcrumb-item>首页</el-breadcrumb-item>
        <el-breadcrumb-item>品牌专区</el-breadcrumb-item>
        <el-breadcrumb-item>{{ pname }}</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="bigimg_main" v-if="type == 101">
        <div class="item" v-for="item in list" :key="item.id">
          <bigimg :item="item" />
        </div>
        <div class="empty">
          <el-empty v-if="!list.length" :image-size="200"></el-empty>
        </div>
      </div>
      <div class="list_main" v-if="type == 102">
        <list :data="list" />
      </div>
      <pagination :total="total" :currentPage="page" :pageSize="page_size" :pageSizes="[20, 40, 80, 120, 200]" @handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" />
    </div>
  </div>
</template>

<script>
import category from "@/components/category.vue";
import bigimg from "@/components/goodsItem/bigImg.vue";
import list from "@/components/goodsItem/list.vue";
import pagination from "@/components/pagination.vue";
export default {
  components: {
    category,
    bigimg,
    list,
    pagination,
  },
  data() {
    return {
      type: 101,
      list: [],
      topSearch: {}, //顶部搜索条件
      searchData: {}, //筛选条件
      page: 1,
      page_size: 20,
      total: 0,

      area_id: "", //跳转所带参数
      show: true,
      pname: "",
    };
  },
  created() {
    let param = this.$route.params;
    if (JSON.stringify(param) !== "{}" && !param.show) {
      this.show = false;
      this.pname = param.pname;
      let p = {
        brand_id: param.brand_id,
      };
      this.getGoods(p);
    } else {
      let value = this.$route.query.value;
      if (value) {
        let arr = value.split("&");
        arr.forEach((v) => {
          let index = v.indexOf("area_id");
          if (index != -1) {
            let result = v.substr(index + 8, v.length);
            this.area_id = result;
          }
        });
      }
      let p = {
        area_id: this.area_id,
        ...this.$store.getters.searchKey,
        order_key: 101, //默认综合排序 升序
        order_desc: 101,
      };
      this.getGoods(p);
    }
  },
  mounted() {
    this.$bus.$on("updateSearch", this.updateSearch);
  },
  methods: {
    getGoods(data) {
      this.$api("goods.getGoods", {
        ...data,
        page: this.page,
        page_size: this.page_size,
      }).then((res) => {
        this.list = res.data;
        this.total = res.listTotal;
      });
    },
    updateSearch(e) {
      this.show = true;
      this.topSearch = e;
      this.page = 1;
      console.log(this.topSearch, "顶部搜索条件");
      this.getGoods(e);
    },
    sendSearch(p) {
      this.searchData = {
        ...p,
        ...this.$store.getters.searchKey,
        scqy_ctr: p.scqy_key,
        sku_ctr: p.sku_key,
      };
      console.log(this.searchData, "筛选条件");
      this.page = 1;
      this.getGoods({ ...this.searchData, area_id: this.area_id });
    },
    handleSizeChange(val) {
      this.page_size = val;
      if (this.$store.getters.searchKey.kw) {
        this.getGoods({ ...this.searchData, ...this.$store.getters.searchKey });
      } else {
        this.getGoods({ ...this.searchData, area_id: this.area_id });
      }
    },
    handleCurrentChange(val) {
      this.page = val;
      if (this.$store.getters.searchKey.kw) {
        this.getGoods({ ...this.searchData, ...this.$store.getters.searchKey });
      } else {
        this.getGoods({ ...this.searchData, area_id: this.area_id });
      }
    },
    sendType(type) {
      this.type = type;
    },
  },
  destroyed() {
    this.$bus.$off("updateSearch", this.updateSearch);
  },
};
</script>

<style lang="less" scoped>
.branditem{
  padding-top:20px
}
.allGoods_container {
  background-color: #fff;
  .bigimg_main {
    display: flex;
    flex-wrap: wrap;
    margin-top: 20px;
  }
  .item {
    margin-right: 12px;
  }
  .item:nth-child(5n) {
    margin-right: 0;
  }
  .list_main {
    margin-top: -10px;
  }
  .empty {
    display: flex;
    justify-content: center;
    width: 100%;
  }
}
</style>
